<template>
  <div class="app">
    <div id="appHeader">
      <div :class="$route.meta.authBackground || checkAppRoute() ? 'app-auth-sticky' : 'app-sticky'"
        :style="$commonMethod.customAppHeader(2, 0)">
        <div class="searchHeader" :style="$commonMethod.customAppHeader(2, 0)" v-if="$route.meta.searchHeader">
          <div class="searchBox">
            <div class="searchWrapper">
              <div class="searchInfo" @click="searchProduct">
                <div class="searchText">{{ $t.meta.search }}</div>
                <figure class="searchLogo">
                  <img class="searchLogoIcon" src="~assets/img/client/icon_home_search@2x.png" />
                </figure>
              </div>
            </div>
            <div class="searchCamera">
              <van-uploader :after-read="afterRead">
                <img class="searchCameraIcon" src="~assets/img/home/camera.png" />
              </van-uploader>
            </div>
          </div>
        </div>
        <van-nav-bar :title="$route.meta.title" :left-arrow="$route.meta.leftBtnHide || checkAppRoute() ? false : true"
          @click-left="onClickLeft" v-else>
          <template #right>
          </template>
        </van-nav-bar>
      </div>
    </div>
    <div id="appContent">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <footer>
      <van-tabbar v-show="$route.meta.footerShow" v-model="active" active-color="#0090e6" inactive-color="#A8A9A9"
        safe-area-inset-bottom :class="platform == 'ios' ? 'ios-footer' : 'android-footer'">
        <div class="blocker" v-if="showBlocker" @click="onAuth"></div>
        <van-tabbar-item v-for="(item, index) in tabbars" :key="index" :to="item.path"
          @click="onChange(index, item.path, item.name)">
          <span>{{ item.title }}</span>
          <template slot="icon" slot-scope="props">
            <img :src="props.active ? item.active : item.normal" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </footer>
  </div>
</template>

<script>
import Vue from "vue";
import { Grid, GridItem, Icon, Image, Button, Tabbar, TabbarItem, NavBar, Uploader } from "vant";
import { getRoute, getPlatform } from "@/plugins/environment/type.js";

Vue.use(Grid).use(GridItem).use(Icon).use(Image).use(Button).use(Tabbar).use(TabbarItem).use(NavBar).use(Uploader)
export default {
  name: "App",
  data() {
    return {
      platform: getPlatform(),
      active: 0,
      route: "app",
      showBlocker: false,
      shopAuth: {},
      tabbars: [
        {
          path: getRoute() + "home",
          name: "Home",
          title: this.$t.meta.homePage,
          normal: require("@/assets/img/home/icon_tab_home.png"),
          active: require("@/assets/img/home/icon_tab_home_select.png"),
        },
        {
          path: getRoute() + "focus/follow",
          name: "Focus",
          title: this.$t.meta.followPage,
          normal: require("@/assets/img/home/icon_tab_like.png"),
          active: require("@/assets/img/home/icon_tab_like_select.png"),
        },
        {
          path: getRoute() + "user/userManage",
          name: "User",
          title: this.$t.meta.userPage,
          normal: require("@/assets/img/home/icon_tab_my.png"),
          active: require("@/assets/img/home/icon_tab_my_select.png"),
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      let auth = JSON.parse(localStorage.getItem("auth"));
      if (auth) {
        this.shopAuth.IsShopSubmit = auth.IsShopSubmit;
        this.shopAuth.IsShopCheck = auth.IsShopCheck;
        if (to.path.includes("home")) {
          if (this.shopAuth.IsShopSubmit == 1 && this.shopAuth.IsShopCheck == 1) {
          } else {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
              isParams: false,
              path: "user/userManage",
              name: "User",
              query: [],
            });
          }
        } else if (to.path.includes("focus")) {
          if (this.shopAuth.IsShopSubmit == 1 && this.shopAuth.IsShopCheck == 1) {
          } else {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
              isParams: false,
              path: "user/userManage",
              name: "User",
              query: [],
            });
          }
        } else if (to.path.includes("user")) {
          if (this.shopAuth.IsShopSubmit == 1 && this.shopAuth.IsShopCheck == 1) {
            this.showBlocker = false;
          } else {
            this.showBlocker = true;
          }
        }
      }
      setTimeout(() => {
        this.setContentClasses(to.meta.stickyHeader);
      });
    },
  },
  methods: {
    setContentClasses(isSticky) {
      const element = document.getElementById("appContent");
      var classes = [];
      if (isSticky) {
        if (this.platform == "ios") {
          classes.push("ios-content");
        }
        if (this.platform == "android") {
          classes.push("android-content");
        }
      }
      var isAuth = this.$route.path.includes("auth");
      var isNotApp = this.$route.path == "/" + this.route;
      if (isAuth || isNotApp) {
        classes.push("none-bottom");
      } else {
        classes.push("mb-bottom");
      }
      element.className = classes.join(" ");
    },
    onAuth() {
      this.$commonMethod.checkAuth(this.shopAuth);
    },
    onChange(index) {
      this.active = index;
      if (this.active == index) {
        window.scrollTo({
          top: 0,
        });
      }
      if (this.active == 0) {
        this.$bus.$emit("HomeRefresh", true);
      }
    },
    onClickLeft() {
      var isLogin = false;
      var auth = JSON.parse(localStorage.getItem("auth"));
      if (auth && auth.token) {
        isLogin = true;
      } else {
        isLogin = false;
      }
      var isPrivacy = JSON.parse(localStorage.getItem("isPrivacy"));
      if (this.$route.path == this.getAppRoute() + 'terms/agreement' || this.$route.path == this.getAppRoute() + 'terms/privacy' || this.$route.path == this.getAppRoute() + 'goodsTerms/shippingRules' || this.$route.path == this.getAppRoute() + 'goodsTerms/returnRules') {
        if (isLogin) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.backUser);
        } else {
          if (isPrivacy) {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
              isParams: false,
              path: "auth/login",
              name: "auth/login",
              query: [],
            });
          } else {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
              isParams: false,
              path: this.getAppRoute(),
              name: this.getAppRoute(),
              query: [],
            });
          }
        }
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
      }
    },
    getAppRoute() {
      return '/' + this.route + '/'
    },
    checkAppRoute() {
      if (this.$route.path == '/' + this.route + '/') {
        return true
      } else {
        return false
      }
    },
    searchWithPic(data) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "search",
        name: "search",
        query: [
          {
            name: "ProductPic",
            value: data,
          },
        ],
      });
    },
    searchProduct() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "searchHistory",
        name: "search",
        query: [],
      });
    },
    afterRead(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      this.$commonMethod.showLoading();
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.searchWithPic(res.data.DefaultUrl);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
  },
  created() {
    this.active = 0;
    this.route = getRoute(true);
  },
  updated() {
    if (this.$route.path.includes("home")) {
      this.active = 0;
    } else if (this.$route.path.includes("focus")) {
      this.active = 1;
    } else if (this.$route.path.includes("user")) {
      this.active = 2;
    } else {
      this.active = 0;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";

.app {
  $-headerhight: 50px;
  $-backgroundColor1: linear-gradient(left, #25b9ff, #0090e6);
  $-backgroundColor2: linear-gradient(left, #25b9ff, #3abcfb);

  #appHeader {

    // 默认页头
    .app-sticky {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      background: $-backgroundColor1;
    }

    // 登录专属页头
    .app-auth-sticky {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      background: $-backgroundColor2 !important;

      ::v-deep .van-nav-bar {
        background: $-backgroundColor2 !important;

        .van-nav-bar__title {
          color: transparent !important;
        }
      }
    }

    ::v-deep .van-nav-bar {
      background: $-backgroundColor1;
      line-height: $-headerhight;
      height: $-headerhight;

      .van-nav-bar__content {
        line-height: $-headerhight;
        height: $-headerhight;

        .van-nav-bar__arrow {
          color: #fff;
          font-size: 2rem;
        }

        .van-nav-bar__title {
          color: #fff;
          font-size: 1.2rem;
        }
      }
    }

    .van-hairline--bottom::after {
      display: none;
    }
  }


  footer {
    height: auto;
    line-height: 1rem;
    color: #fff;
  }

  footer img {
    width: 1.5rem;
    height: 1.5rem;
  }

  footer ::v-deep .ios-footer {
    height: auto;
    color: #999;
    z-index: 100 !important;
    padding-top: 5px;
    padding-bottom: calc(5px + env(safe-area-inset-bottom));
  }

  footer ::v-deep .android-footer {
    height: auto;
    color: #999;
    z-index: 100 !important;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .ios-content {
    margin-top: calc($-headerhight + env(safe-area-inset-top));
  }

  .android-content {
    margin-top: $-headerhight;
  }

  footer .blocker {
    position: absolute;
    width: 66.66%;
    height: 100%;
    z-index: 10;
    background: rgb(211, 211, 211, 0.2);
  }

  .none-bottom {
    margin-bottom: 0vw;
  }

  .mb-bottom {
    margin-bottom: 30vw;
  }

  .searchHeader {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    background: $-backgroundColor1;

    .searchBox {
      padding: 7.5px 0px;
      background: $-backgroundColor1;

      .searchWrapper {
        width: 85%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;

        .searchInfo {
          width: 90%;
          padding: 5px;
          border-radius: 10px;
          background-color: #ffffff;
          display: inline-block;
          position: relative;
          vertical-align: middle;
          text-align: left;

          .searchText {
            display: inline-block;
            margin-left: 30px;
            font-size: 14px;
            background-color: #ffffff;
            color: #a7a7a7;
            line-height: 25px;
          }

          .searchLogo {
            margin: 0;
            padding: 0;
            position: absolute;
            justify-content: center;
            -webkit-justify-content: center;
            left: 7px;
            top: 7px;
            @include publicFlex;

            .searchLogoIcon {
              width: 21px;
              height: 21px;
              object-fit: cover;
              -webkit-object-fit: cover;
            }
          }
        }
      }

      .searchCamera {
        width: 15%;
        display: inline-block;
        text-align: center;
        vertical-align: middle;

        .searchCameraIcon {
          width: 25px;
          height: 25px;
          object-fit: cover;
          -webkit-object-fit: cover;
        }
      }
    }
  }
}
</style>
